export type Service = {
  id: number
  guid: string
  refServicesKategorieId: number
  sortIndex: number
  name: string
  beschreibung: string
  preis: string
  rabattPreis: number
  minuten: number
}

export type ServiceCategory = {
  id: number
  guid: string
  refSalonId: number
  sortIndex: number
  name: string
  beschreibung: string
  services: Service[]
}

export enum ServicesActionTypes {
  FETCH_REQUEST = '@@services/FETCH_REQUEST',
  FETCH_SUCCESS = '@@services/FETCH_SUCCESS',
  FETCH_ERROR = '@@services/FETCH_ERROR',
  SELECT_SERVICE = '@@services/SELECT_SERVICE',
  CLEAR_SELECTED = '@@services/CLEAR_SELECTED'
}

// Declare state types with `readonly` modifier to get compile time immutability.
// https://github.com/piotrwitek/react-redux-typescript-guide#state-with-type-level-immutability
export interface ServicesState {
  readonly loading: boolean
  readonly data: ServiceCategory[]
  readonly selected: Service[]
  readonly errors?: string
}
